import { RecordScreen } from "@/lib/Components/Screens/RecordScreen/RecordScreen";
import { DocumentTextIcon } from "@heroicons/react/24/outline";
import { usePaymentRecord } from "@/app/Payments/Hooks/usePaymentRecord";
import { Badge } from "@/components/catalyst/badge";
import { paymentStatusColorMap } from "@/app/Payments/Utils/paymentColorMaps";

export function PaymentRecordScreen() {
  const payment = usePaymentRecord();

  return (
    <RecordScreen
      tabParams={{ id: payment.id }}
      title={`Payment #${payment.id}`}
      badges={
        <Badge color={paymentStatusColorMap[payment.status]}>
          {payment.status}
        </Badge>
      }
      tabs={[
        {
          name: "Details",
          to: "/$tenant/$orgId/supplier/{-$supplierId}/payments/$id",
          Icon: DocumentTextIcon,
        },
      ]}
    />
  );
}
